import keys from '@debbie/common/dist/cache/keys.js';
import { DocumentTypes, } from '@debbie/common/dist/documents/index.js';
import * as documentsAPI from '@debbie/cortex/dist/api/documents.js';
import { documentsEntity } from '@debbie/cortex/dist/documents/index.js';
import q from '@debbie/cortex/dist/query.js';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../theme.js';
import { Button, Checkbox, File, FileDropzone, Modal, Well } from '../index.js';
const AddDocumentModal = (props) => {
    const dropzoneRef = useRef(null);
    const lang = useSelector((s) => s.lang);
    const [isSigned, setIsSigned] = useState(false);
    const [pendingDocuments, setPendingDocuments] = useState([]);
    const [isVisibleForDebtor, setIsVisibleForDebtor] = useState(false);
    const [loadingDocumentFromFile, setLoadingDocumentFromFile] = useState(false);
    useEffect(() => {
        if (props.documentState.pendingDocuments.length) {
            setPendingDocuments([...props.documentState.pendingDocuments]);
        }
    }, []);
    const uploadDocument = async () => {
        setLoadingDocumentFromFile(true);
        for (let i = 0; i < pendingDocuments.length; i++) {
            const document = pendingDocuments[i];
            await documentsAPI.add(props.entityId, DocumentTypes.OTHER, props.entityType, document, isSigned, undefined, undefined, isVisibleForDebtor ? 'debtor' : undefined);
        }
        q.invalidate(keys.write.create(documentsEntity));
        setLoadingDocumentFromFile(false);
        props.toggleModal();
    };
    let files = pendingDocuments;
    return (React.createElement(Modal, { maxWidth: "400px", onToggle: props.toggleModal, header: lang.documents.addDocument },
        React.createElement(FileDropzone, { onChange: (file) => {
                // Used to set files within rerendering
                files = [...files, file];
                setPendingDocuments(files);
            }, dropzoneRef: dropzoneRef },
            React.createElement("h2", null, lang.documents.fromFile),
            React.createElement(Well, null,
                pendingDocuments.map((file, i) => (React.createElement("div", { key: file.fileId, style: { marginBottom: `${THEME.GRID_SPACING}px` } },
                    React.createElement(File, { file: file, removable: true, onRemove: () => {
                            setPendingDocuments(pendingDocuments.filter((docs, index) => index !== i));
                        } })))),
                React.createElement(Button, { onClick: () => {
                        //@ts-ignore
                        dropzoneRef.current?.open();
                    }, size: "small", theme: "secondary", block: true }, lang.documents.addDocument),
                React.createElement("br", null),
                React.createElement(Checkbox, { placeholder: lang.documents.documentSignedCheckbox, checked: isSigned, onChange: (e) => setIsSigned(e.target.checked) }),
                React.createElement(Checkbox, { placeholder: lang.documents.visibleForDebtor, checked: isVisibleForDebtor, onChange: (e) => setIsVisibleForDebtor(e.target.checked) }),
                React.createElement(Button, { disabled: !(pendingDocuments.length > 0), loading: loadingDocumentFromFile, onClick: uploadDocument, size: "small", block: true }, lang.documents.uploadDocument)))));
};
export default AddDocumentModal;
//# sourceMappingURL=AddDocumentModal.js.map